import { Component } from '@angular/core';

@Component({
  selector: 'app-unautorized',
  templateUrl: './unautorized.component.html',
  styleUrls: ['./unautorized.component.scss'],
})
export class UnautorizedComponent {}
